import { NavigateWithThread, FocusDashboard, ProfilePage } from '@yeshuman/sdk'
import { Routes, Route } from 'react-router-dom'
import { PatientConsultStubPage } from '../components/patient-consult-stub-page'

interface PatientRoutesProps {
  onStartConversation?: (message: string) => void
}

export function PatientRoutes({ onStartConversation }: PatientRoutesProps) {
  return (
    <Routes>
      <Route
        index
        element={
          <FocusDashboard
            focus="patient"
            onStartConversation={onStartConversation}
          />
        }
      />
      <Route path="profile" element={<ProfilePage />} />
      <Route path="consult" element={<PatientConsultStubPage />} />
      <Route path="consult/:sessionId" element={<PatientConsultStubPage />} />
      <Route path="*" element={<NavigateWithThread to="" />} />
    </Routes>
  )
}

